import React from 'react'
import AppRouter from './router/AppRouter'

const App = () => {
  return (
    <div>
      <AppRouter/>
    </div>
  )
}

export default App